import { setLocationPermission, setSelectedShop, setSnackbar } from '../store/features/app/appSlice';
import { applyDeviceLocation, requestDeviceLocation } from '../components/PrintMap/mapServices';
import { appleLogin, loginGoogle } from '../store/features/user/userServices';
import { getTeam } from '../store/features/team/teamServices';
import { getPrinterLocation, handlePrinterScanCode } from '../store/features/app/appServices';
import { persistor, store } from '../store/configureStore';
import { setInstantQouteStep } from '../store/features/order/orderSlice';
import i18n from '../i18nconfig';
import { nativeAppSupports, stepAfterPrinterScan } from '../utils/nativeApp';
// After signing in from the app the page reloads: the signed-in user is saved first, or the reload can come before
// the (asynchronous) save and the page reloads still as the guest, though the API signed the user in
const reloadSignedIn = async () => {
  store.dispatch(getTeam());
  await persistor.flush();
  window.location.href = '/';
};

export class TypescriptManager {
  qrCodeReceived = (qrCode: any) => {
    let selectedPrinter;
    let status = '';
    if (typeof qrCode === 'string') {
      selectedPrinter = qrCode;
    } else if (qrCode && qrCode.text) {
      selectedPrinter = qrCode.text;
    } else {
      status = i18n.t('messages.errorTryAgain');
      return;
    }

    store.dispatch(handlePrinterScanCode({ selectedPrinter })).then(async (res) => {
      if (res.meta.requestStatus === 'rejected') {
        status = res?.payload?.message;
        return store.dispatch(setSnackbar({ open: true, message: i18n.t('error.printerNotFound'), type: 'error' }));
      }
      if (res.meta.requestStatus === 'fulfilled') {
        // The scanned printer's shop is the order's printing location (shown on the checkout map), replacing any
        // shop picked earlier
        const location = await store.dispatch(getPrinterLocation({ locationId: Number(res.payload.location_id) }));
        store.dispatch(setSelectedShop(location.meta.requestStatus === 'fulfilled' ? (location.payload as any) : null));
        store.dispatch(setInstantQouteStep(stepAfterPrinterScan(store.getState().order.instantQuoteStep)));
      } else {
        store.dispatch(setSnackbar({ open: true, message: i18n.t('error.invalidQrCode'), type: 'error' }));
      }
    });
  };

  // From the app. The native apps also send the phone's coordinates; the older Flutter app only says
  // whether location is allowed, so the browser is asked for the position instead.
  locationPermision(hasPermision: boolean, location?: { latitude: number; longitude: number }) {
    if (hasPermision && location && typeof location.latitude === 'number') {
      applyDeviceLocation(location);
      return;
    }
    store.dispatch(setLocationPermission(hasPermision));

    // An app that sends coordinates has already tried: without them there's no position to get, and asking it
    // again would loop (the app answers the same way every 10 seconds)
    if (hasPermision && !nativeAppSupports('locationCoords')) {
      requestDeviceLocation();
    }
  }

  // From the app: the native apps send a Google ID token
  googleLogin = (idToken: string) => {
    store.dispatch(loginGoogle({ idToken })).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        reloadSignedIn();
      }
    });
  };

  appleLogin(response: string) {
    store.dispatch(appleLogin(response)).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        reloadSignedIn();
      }
    });
  }

  render() {
    return null;
  }
}

window.typescriptManager = new TypescriptManager();
